import { FileCategory, FileCategoryRequestFilter } from '@/modules/files/entities/fileCategories.interfaces';
import { FileParams, FileResponse, FileToUpload } from '@/modules/files/entities/fileEntity';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

class FilesService extends HttpClientAdapter {
  constructor() {
    super('FILES');
  }

  getCategories(filters?: Partial<FileCategoryRequestFilter>): Promise<FileCategory[]> {
    return this.get<FileCategory[]>('/categories', filters);
  }

  getFiles(companyId: string, params?: Partial<FileParams>): Promise<FileResponse> {
    const url = `/companies/${companyId}/files`;
    return this.get<FileResponse>(url, params);
  }

  getDownloadToken(companyId: string, idFile: string) {
    return this.get(`/companies/${companyId}/files/${idFile}`);
  }

  deleteFile(companyId: string, idFile: string) {
    return this.delete(`/companies/${companyId}/files/${idFile}`);
  }

  uploadFile(companyId: string, data: FileToUpload) {
    const formData = new FormData();
    formData.append('file', data.file);
    data.categoryIds.forEach((categoryId) => {
      formData.append('categoryIds[]', categoryId);
    });

    return this.post(`/companies/${companyId}/files`, formData);
  }
}

export default FilesService;
